import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const iconDefaultVariants = {
  "size": "l"
}
const iconCompoundVariants = []

const iconSlotNames = [
  [
    "root",
    "icon__root"
  ],
  [
    "svg",
    "icon__svg"
  ],
  [
    "root",
    "icon__root"
  ],
  [
    "svg",
    "icon__svg"
  ]
]
const iconSlotFns = /* @__PURE__ */ iconSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, iconDefaultVariants, getSlotCompoundVariant(iconCompoundVariants, slotName))])

const iconFn = memo((props = {}) => {
  return Object.fromEntries(iconSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const iconVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...iconDefaultVariants, ...compact(variants) })

export const icon = /* @__PURE__ */ Object.assign(iconFn, {
  __recipe__: false,
  __name__: 'icon',
  raw: (props) => props,
  variantKeys: iconVariantKeys,
  variantMap: {
  "size": [
    "xs",
    "xl",
    "s",
    "m",
    "l"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, iconVariantKeys)
  },
  getVariantProps
})